import React from 'react'
import PropTypes from 'prop-types'
import { P101_1, P102_1, P108_3 } from 'rpqs/constants/RpqsConstant'
import DialogP102_1 from './DialogP102_1'
import DialogP101_1 from './DialogP101_1'
import DialogP108_3 from './DialogP108_3'

const QualityDialog = ({
    open = false,
    setOpen = () => {},
    codeIndicator = '',
    dialogTitle = '',
}) => {
    return (
        <>
            {codeIndicator === P102_1.code &&
                <DialogP102_1
                    open={open}
                    setOpen={setOpen}
                    title={dialogTitle}
                />
            }
            {codeIndicator === P101_1.code &&
                <DialogP101_1
                    open={open}
                    setOpen={setOpen}
                    title={dialogTitle}
                />
            }
            {codeIndicator === P108_3.code &&
                <DialogP108_3
                    open={open}
                    setOpen={setOpen}
                    title={dialogTitle}
                />
            }
        </>
    )
}

QualityDialog.propTypes = {
    setOpen: PropTypes.func,
    open: PropTypes.bool,
    codeIndicator: PropTypes.string,
    dialogTitle: PropTypes.string,
}

export default QualityDialog